<template>
  <div class="col-12 mb-3" v-if="dashboardStore.filter !== 'Card'">
    <div class="card h-100">
      <div class="card-header">
        <h4>Active drivers by payment method</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-4">
            <h5>Cash</h5>
            <hr>
            <h3>{{ active_drivers.cash ?? 0 }}</h3>
          </div>
          <div class="col-4">
            <h5>Bank transfer</h5>
            <hr>
            <h3>{{ active_drivers.bank ?? 0 }}</h3> 
          </div>
          <div class="col-4">
            <h5>Prepaid card</h5>
            <hr>
            <h3>{{ active_drivers.prepaid ?? 0 }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useDashboardStore } from '@/store/admin/dashboard';

const dashboardStore = useDashboardStore();

// 直接從 store 中取出已經載入的數據
const active_drivers = computed(() => dashboardStore.active_drivers_by_payment_method);
</script>
